<template>
    <div>
        <b-modal id="modal-prevent-closing" centered class="header-modal" no-close-on-backdrop hide-footer ref="modal-warning-change-public-to-private">
            <div class="modal-warning-change-public-to-private__body container wrap-form-create-update-chapter">
                <h4>
                    <strong>
                        Cảnh báo
                    </strong>
                </h4>
                <p class="font-size-17 primary-color-txt font-sanpro-light">
                    Bài giảng điện tử sẽ bị thu hồi với các lớp đã giao khi chuyển sang trạng thái chưa công khai.
                </p>
                <div class="modal__actions text-right">
                    <a href="javascript:;" class="font-size-17 font-weight-bold btn-cancel px-4" @click="handleHideModal">Hủy</a>
                    <a href="javascript:;" class="btn btn-primary font-size-17 font-sanpro-semibold btn-delete px-4" @click="handleChangeDone()">Xác nhận</a>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { recoveryAssignLessonClassSchool } from './../../../_api/LessonClassSchoolServices'

export default {
    name: "ModalWarningChangePublicToPrivate",
    props: {
        itemSelected: {
            type: Object,
            default: {}
        },
    },
    data() {
        return {
            confirmActive: {},
            isLoading: false,
        }
    },
    mounted(){
        this.handleShowModal()
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },
        
    },
    methods: {
        
        handleChangeDone() {
            let self = this
            recoveryAssignLessonClassSchool({id:this.itemSelected.id}).then((res)=>{
                if (res && res.data && !res.errors) {
                    self.$toast.success('Thay đổi chế độ công khai thành công')
                    self.$emit('handleChangeDone')
                }
            })
        },
        handleHideModal() {
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-warning-change-public-to-private'].show()
        }
    }
}
</script>
<style lang="scss" scoped>
.modal-content {
    background-color: red;
}

.modal-warning-change-public-to-private__body {
    padding: 20px;
    background-color: white;
    .modal__actions{
        
        .btn-delete{
            color: white;
            height: auto;
            border-radius: 8px;
            font-family: sans-serif;
        }
        .btn-cancel{
            color: #212529;
            margin-right: 10px;
            font-family: sans-serif;
        }
    }
}

.form_action {
    margin-top: 10px;
    padding-bottom: 10px;
}

.justity-content-space-between {
    justify-content: center
}
</style>